import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {faCloudUploadAlt, faDownload, faExpand, faEye, faFileImport, faInfoCircle, faPen, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ShipmentServiceService} from 'src/app/share/services/shipment/shipment-service.service';
import mime from 'mime';
import {MessageService} from 'src/app/material-register/shared-message';
import {Subscription} from 'rxjs';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';
import {StorageKeys} from 'src/app/share/enums/storage.enum';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { DocumentValutService } from 'src/app/share/document-valut/document-valut.service';

interface TableRow {
  isGroupRow?: boolean;
  lrNumber: string;
  field: string;
  expected: string;
  extracted: string;
  pageNumber : string;
  status: string;
  isUpdated : boolean;
}
@Component({
    selector: 'app-outbound-view',
    templateUrl: './outbound-view.component.html',
    styleUrl: './outbound-view.component.scss',
    standalone: false
})
export class OutboundViewComponent implements OnInit {

  public faEye = faEye;
  public faPen = faPen;
  public faDownload = faDownload;
  public faExpand = faExpand;
  public faFileImport = faFileImport;
  protected readonly faCloudUploadAlt = faCloudUploadAlt;
  protected readonly faSpinner = faSpinner;
  protected readonly faInfoCircle = faInfoCircle;
  loadRecords: boolean = false;
  materialList: any;
  errorMessage: any;
  @ViewChild('documentModal', { static: true }) documentModal!: TemplateRef<any>;
  modalRef!: NgbModalRef;
  inboundLog: any;
  endResult: boolean = false;
  params: any = { page: 0 };
  fileDetails: any;
  missMatchLog: any;
  updateHistory: any;
  isUploadDocuments: boolean = false;
  selectedMaterial: any;
  materialId: any;
  isSuccessToster: boolean = false;
  message: any;
  subscription: Subscription;
  selfDetails: any;
  isPrimary: boolean = false;
  isSameCompany: boolean = false;
  docId: any;
  paramsAuditLog: any = { page: 0 };
  paramsUpdateHistory: any = { page: 0 };
  companyId: any;
  selectedCompanyId: any;
  tableData: { headers: string[]; data: TableRow[];} = { headers: [],data: []};
  rootCompanyDocumentId: any;
  isLoading: boolean = false;
  loader: boolean = false;
  @Input() material: any;
  @Input() isModal: boolean = false;
  loadingRecords: boolean = false;
  isErrorToster: boolean = false;

  constructor(private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly shipmentService: ShipmentServiceService,
    private readonly sanitizer: DomSanitizer,
    private readonly modalService: NgbModal,
    private readonly messageService: MessageService,
    private readonly storageService: StorageService,
    private readonly location: Location,
    private readonly documentValutService: DocumentValutService,
    private readonly httpClient: HttpClient
  ) {
    this.message = sessionStorage.getItem('material-message');
    if (this.message) {
      this.isSuccessToster = true;
    }
    sessionStorage.removeItem('material-message');
   }

  ngOnInit() {
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.companyId = this.selfDetails?.company;
    this.isPrimary = this.selfDetails?.assignedTo?.some((assignment: any) => assignment.primary);
    this.route?.queryParams.subscribe(params => {
      const encryptedId = params['id'] || this.storageService.encrypt(localStorage.getItem('materialId'));
      this.isSameCompany = params['isSameCompany'] === 'true';
      this.selectedCompanyId = this.storageService.decrypt(params['selectedCompany']);
      if (encryptedId && !this.isModal) {
        const id = this.storageService.decrypt(encryptedId);
        this.materialId = id;
        this.getMaterialDetails(this.materialId);
        this.getUpdateHistory(this.materialId);
      }
      this.location.replaceState(this.router.url.split('?')[0]);
    });
    if (this.isModal && this.material) {
      this.getMaterialDetails(this.material);
      this.getUpdateHistory(this.material);
    }
  }

  getMaterialDetails(materialid: any) {
    this.loadRecords = true;
    this.shipmentService.getSubOutBoundMaterialList(materialid,this.params)?.subscribe({
      next: (res: any) => {
        this.loadRecords = false;
        if (res?.data) {
          this.materialList = {
            shipmentType: res?.data?.shipmentType,
            shipmentMode: res?.data?.shipmentMode,
            uniqueId: res?.data?.uniqueId,
            status: res?.data?.status,
            transporter: res?.data?.transporterName?.name,
            freightForwarder: res?.data?.freightForwarder?.name,
            subTransporter : res?.data?.subTransporterName?.name,
            truckNo: res?.data?.truckNumber,
            remarks: res?.data?.remarks,
            lrData: res?.data?.shipmentDetails.map((shipment: any) => ({
              lrNo: shipment?.lrNo,
              totalBoxes: shipment?.totBoxes,
              palletBoxes: shipment?.palletBoxes,
              bins: shipment?.bins,
              trolleys: shipment?.trolleys,
              dollies: shipment?.dollies,              
              customer: shipment?.invoiceDetails.map((invoice: any) => invoice?.customer?.name),
              invoice: shipment?.invoiceDetails.map((invoice: any) => invoice?.invoiceNo),
              eWayBill: shipment?.invoiceDetails.map((invoice: any) => invoice?.eWayBill),
              invoiceDate: shipment?.invoiceDetails?.map((invoice: any) =>
                invoice?.invoiceDate ? new Date(invoice?.invoiceDate) : ''
              ) || []
            })),
            document: res?.data?.documents[0] || null,
            ocrShipmentDetails: res?.data?.ocrShipmentDetails || []
          };
          if (this.materialList.document) {
            this.docId = this.materialList.document;
            this.getFileDetails(this.docId,true);
          }
          const ocrData = res?.data?.ocrShipmentDetails;
          this.tableData = {
            headers: ['LR Number', 'Field Name', 'Entered Values', 'Extracted Values','Page Number', 'Validation Status'],
            data: []
          };  
          if (ocrData) {
            if (ocrData.truckNumber) {
              this.tableData.data.push({
                lrNumber: '',
                field: ocrData.truckNumber.field,
                expected: ocrData.truckNumber.expected,
                extracted: ocrData.truckNumber.extracted,
                pageNumber: ocrData.truckNumber.pageNumber,
                status: ocrData.truckNumber.status,
                isUpdated: ocrData.truckNumber.isUpdated
              });
            }
            if (ocrData.transporterName?.name) {
              const transporter = ocrData.transporterName.name;
              this.tableData.data.push({
                lrNumber: '',
                field: transporter.field,
                expected: transporter.expected,
                extracted: transporter.extracted,
                pageNumber: transporter.pageNumber,
                status: transporter.status,  
                isUpdated: transporter.isUpdated 
              });
            }
            if (ocrData.subTransporterName?.name) {
              const transporter = ocrData.subTransporterName.name;
              this.tableData.data.push({
                lrNumber: '',
                field: transporter.field,
                expected: transporter.expected,
                extracted: transporter.extracted,
                pageNumber: transporter.pageNumber,
                status: transporter.status,  
                isUpdated: transporter.isUpdated 
              });
            }
            ocrData.shipmentDetails?.forEach((shipment: any) => {
              const lrNumber = shipment?.lrNo?.expected || '';
              if (shipment?.lrNo) {
                this.tableData.data.push({
                  isGroupRow: true,
                  lrNumber,
                  field: shipment.lrNo.field,
                  expected: shipment.lrNo.expected,
                  extracted: shipment.lrNo.extracted,
                  pageNumber: shipment.lrNo.pageNumber,
                  status: shipment.lrNo.status,
                  isUpdated: shipment.lrNo.isUpdated 
                });
              }
              if (shipment?.totBoxes) {
                this.tableData.data.push({
                  lrNumber: '',
                  field: shipment.totBoxes.field,
                  expected: shipment.totBoxes.expected,
                  extracted: shipment.totBoxes.extracted,
                  pageNumber: shipment.totBoxes.pageNumber,
                  status: shipment.totBoxes.status,
                  isUpdated: shipment.totBoxes.isUpdated 
                });
              }
              if (shipment?.palletBoxes) {
                this.tableData.data.push({
                  lrNumber: '',
                  field: shipment.palletBoxes.field,
                  expected: shipment.palletBoxes.expected,
                  extracted: shipment.palletBoxes.extracted,
                  pageNumber: shipment.palletBoxes.pageNumber,
                  status: shipment.palletBoxes.status,
                  isUpdated: shipment.palletBoxes.isUpdated
                });
              }
              if (shipment?.bins) {
                this.tableData.data.push({
                  lrNumber: '',
                  field: shipment.bins.field,
                  expected: shipment.bins.expected,
                  extracted: shipment.bins.extracted,
                  pageNumber: shipment.bins.pageNumber,
                  status: shipment.bins.status,
                  isUpdated: shipment.bins.isUpdated
                });
              }
              if (shipment?.trolleys) {
                this.tableData.data.push({
                  lrNumber: '',
                  field: shipment.trolleys.field,
                  expected: shipment.trolleys.expected,
                  extracted: shipment.trolleys.extracted,
                  pageNumber: shipment.trolleys.pageNumber,
                  status: shipment.trolleys.status,
                  isUpdated: shipment.trolleys.isUpdated
                });
              }
              if (shipment?.dollies) {
                this.tableData.data.push({
                  lrNumber: '',
                  field: shipment.dollies.field,
                  expected: shipment.dollies.expected,
                  extracted: shipment.dollies.extracted,
                  pageNumber: shipment.dollies.pageNumber,
                  status: shipment.dollies.status,
                  isUpdated: shipment.dollies.isUpdated
                });
              }
              if (Array.isArray(shipment?.invoiceDetails)) {
                shipment.invoiceDetails.forEach((invoice: any) => {
                  if (invoice?.invoiceNo) {
                    this.tableData.data.push({
                      lrNumber: '',
                      field: invoice.invoiceNo.field,
                      expected: invoice.invoiceNo.expected,
                      extracted: invoice.invoiceNo.extracted,
                      pageNumber: invoice.invoiceNo.pageNumber,
                      status: invoice.invoiceNo.status,
                      isUpdated: invoice.invoiceNo.isUpdated  
                    });
                  }
                  if (invoice?.invoiceDate) {
                    this.tableData.data.push({
                      lrNumber: '',
                      field: invoice.invoiceDate.field,
                      expected: invoice.invoiceDate.expected,
                      extracted: invoice.invoiceDate.extracted,
                      pageNumber: invoice.invoiceDate.pageNumber,
                      status: invoice.invoiceDate.status,
                      isUpdated: invoice.invoiceDate.isUpdated
                    });
                  }
                  if (invoice?.customer?.name) {
                    const customer = invoice.customer.name;
                    this.tableData.data.push({
                      lrNumber: '',
                      field: customer.field,
                      expected: customer.expected,
                      extracted: customer.extracted,
                      pageNumber: customer.pageNumber,
                      status: customer.status,
                      isUpdated: customer.isUpdated                    
                    });
                  }
                  if (invoice?.eWayBill) {
                    this.tableData.data.push({
                      lrNumber: '',
                      field: invoice.eWayBill.field,
                      expected: invoice.eWayBill.expected,
                      extracted: invoice.eWayBill.extracted,
                      pageNumber: invoice.eWayBill.pageNumber,
                      status: invoice.eWayBill.status,
                      isUpdated: invoice.eWayBill.isUpdated
                    });
                  }
                });
              }
            });
          }          
      }
      },
      error: (error: any) => {
        this.loadRecords = false;
        this.errorMessage = error?.error?.error?.message || "Failed to load data.";
      }
    });
  }

  fetchDocumentThumbnail(docId: string) {
    this.loader = true;
    const companyId = this.selectedCompanyId ? this.selectedCompanyId : this.companyId;
    this.documentValutService.getPresignedUrl(docId, companyId, false).subscribe({
      next: (res: any) => {
        const signedUrl = res?.data?.signedUrl;
        const sseCustomkey = res?.data?.sseCustomkey;
        if (!signedUrl) {
          this.loader = false;
          return;
        }
         const headers = new HttpHeaders(sseCustomkey ? {
            'x-amz-server-side-encryption-customer-algorithm': 'AES256',
            'x-amz-server-side-encryption-customer-key': sseCustomkey
          } : {});
        this.httpClient.get(signedUrl, {
          headers,
          responseType: 'blob',
          observe: 'events',
          reportProgress: true
        }).subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.Response) {
              this.loader = false;
              const response = new Blob([event.body], { type: event.body.type });
              const blobUrl = URL.createObjectURL(response);
              const mimeType = response.type;
              if (mimeType === "application/pdf") {
                this.materialList.documentThumbnailUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
                this.materialList.isPdf = true;
                this.materialList.isImage = false;
                this.materialList.isTiff = false;
              } else if (mimeType.startsWith("image/")) {
                if (mimeType.includes("tiff")) {
                  this.materialList.isTiff = true;
                  this.materialList.isImage = false;
                  this.materialList.documentThumbnailUrl = null;
                } else {
                  this.materialList.documentThumbnailUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
                  this.materialList.isImage = true;
                  this.materialList.isTiff = false;
                }
              } else {
                this.materialList.documentThumbnailUrl = null;
                this.materialList.isPdf = false;
                this.materialList.isImage = false;
                this.materialList.isTiff = false;
              }
            }
          },
          error: (error: any) => {
            this.loader = false;
            console.error("Error fetching thumbnail:", error);
            this.materialList.documentThumbnailUrl = null;
            this.materialList.isPdf = false;
            this.materialList.isImage = false;
            this.materialList.isTiff = false;
          }
        });
      },
      error: (error: any) => {
        this.loader = false;
        console.error("Error fetching presigned url:", error);
      }
    });
  }

  fetchDocumentLog() {
    this.shipmentService.getInboundLog(this.rootCompanyDocumentId, this.paramsAuditLog)?.subscribe({
      next: (res: any) => {
        if (res?.success) {
          if (res.data?.length === 0) {
            this.endResult = true;
          } else if (this.paramsAuditLog.page === 0) {
            this.inboundLog = res.data;
          } else {
            this.inboundLog = [...this.inboundLog, ...res.data];
          }
        }
      },
      error: (error: any) => {
        console.error("Error fetching audit log for document ID:", this.rootCompanyDocumentId, error);
      }
    });
  }

  downloadDocument() {
    this.isLoading = true;
    if (this.materialList?.document) {
      const docId = this.materialList.document;
      const companyId = this.selectedCompanyId ? this.selectedCompanyId : this.companyId;
      this.documentValutService.getPresignedUrl(docId, companyId, true).subscribe({
        next: (res: any) => {
          const signedUrl = res?.data?.signedUrl;
          const sseCustomkey = res?.data?.sseCustomkey;
          if (!signedUrl) {
            this.isLoading = false;
            return;
          }
          const headers = new HttpHeaders(sseCustomkey ? {
            'x-amz-server-side-encryption-customer-algorithm': 'AES256',
            'x-amz-server-side-encryption-customer-key': sseCustomkey
          } : {});
          this.httpClient.get(signedUrl, {
            headers,
            responseType: 'blob',
            observe: 'events',
            reportProgress: true
          }).subscribe({
            next: (event: any) => {
              if (event.type === HttpEventType.Response) {
                this.isLoading = false;
                const response = new Blob([event.body], { type: event.body.type });
                const blobUrl = URL.createObjectURL(response);
                const a = document.createElement('a');
                a.href = blobUrl;
                let fileName = event.headers?.get('file-name') || event.headers?.get('filename') || this.materialList?.uniqueId || 'document';
                if (!fileName.includes('.') && response.type) {
                  const extMap: any = {
                    'application/pdf': '.pdf',
                    'image/png': '.png',
                    'image/jpeg': '.jpg'
                  };
                  const ext = extMap[response.type];
                  if (ext) fileName += ext;
                }

                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                this.isSuccessToster = true;
                this.message = 'File downloaded successfully';
              }
            },
            error: (error: any) => {
              this.isLoading = false;
              console.error("Error downloading file:", error);
            }
          });
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error("Error fetching presigned url:", error);
        }
      });
    }
  }

  back() {
    this.router.navigate(['/material']);
  }

  getStatusStyle(status: string): any {
    switch (status) {
      case 'Pending Document Upload':
      case 'Pending Correction':
        return { 'color': 'red' };
      case 'Pending OCR Validation':
        return { 'color': 'blue' };
      case 'Completed':
        return { 'color': 'green' };
      default:
        return {};
    }
  }

  openDocumentPopup() {
    this.fetchDocumentThumbnail(this.docId);
    this.modalRef = this.modalService.open(this.documentModal, { size: 'xl', centered: true });
  }

  onScrolling() {
    if (this.endResult) {
      return;
    }
    this.params.page++;
    this.getMaterialDetails(this.docId);
  }

  onScroll() {
    if (this.endResult) {
      return;
    }
    this.paramsAuditLog.page++;
    this.fetchDocumentLog();
  }

  onScrolled() {
    if (this.endResult) {
      return;
    }
    this.paramsUpdateHistory.page++;
    this.getUpdateHistory(this.docId);
  }

  getFileDetails(docId: string, fetchLog: boolean = false) {
    this.shipmentService.getFilesDetails(docId)?.subscribe({
      next: (res: any) => {
        this.fileDetails = res?.data || null;
        this.rootCompanyDocumentId = this.fileDetails?.rootCompanyDocument;
        if (this.fileDetails) {
          const mimeType = this.fileDetails.mimeType || '';
          this.fileDetails.isPdf = mimeType === 'application/pdf';
          this.fileDetails.displayImage = this.fileDetails.isPdf
            ? this.fileDetails.thumbnailUrl
            : '../../../assets/Images/document-preview/Files.svg';
        }
        if (fetchLog && this.rootCompanyDocumentId) {
          this.fetchDocumentLog();
        }
      },
      error: (error: any) => {
        console.error('Error fetching file details:', error);
      }
    });
  }

  getFileType(mimeType: any) {
    if (mimeType?.includes('zip')) {
      return 'zip';
    } else if (mimeType == 'application/x-compressed') {
      return 'rar';
    } else {
      return mime.getExtension(mimeType)
    }
  }

  getUpdateHistory(docId: string) {
    this.shipmentService.getUpdateHistory(docId, this.paramsUpdateHistory).subscribe({
      next: (res: any) => {
        if (res?.success) {
          if (res.data?.length === 0) {
            this.endResult = true;
          } else if (this.paramsUpdateHistory.page === 0) {
            this.updateHistory = res.data;
          } else {
            this.updateHistory = [...this.updateHistory, ...res.data];
          }
        }
      },
      error: (error: any) => {
        console.error("Error fetching update history:", error);
      }
    });
  }

  closeUploadOverlay() {
    document.body.style.overflow = '';
    this.isUploadDocuments = false;
    this.getMaterialDetails(this.materialId);
  }

  isUploadDocument() {
    document.body.style.overflow = 'hidden';
    this.selectedMaterial = {
      _id: this.materialId,
      selectedRegister: { key: 'Outward' }
    };
    this.isUploadDocuments = true;
  }

  isEdit(){
    this.router.navigate(['/material/outbound-form'],
      { queryParams: { id: this.storageService.encrypt(this.materialId) } }
    );
  }

  closeToster(value: boolean) {
    this.isSuccessToster = value;
  }

  onUploadSuccess(message: string) {
    this.isSuccessToster = true;
    this.message = message;
  }
  
  downloadSheet() {
    this.loadingRecords = true;
    const params: any = {
      download: true
    }
    this.shipmentService.getSheetDownloadById(this.material, params, 'outbound-material').subscribe({
      next: (response: any) => {
        this.loadingRecords = false;
        this.createDownloadLink(response, 'The file has been successfully downloaded to your device.');
      },
      error: (error: any) => {
        this.loadingRecords = false;
        this.isErrorToster = true;
        this.errorMessage = error?.error?.error?.message || 'Failed to download file. Please try again.';
      }
    });
  }

  createDownloadLink(response: any, successMessage: string) {
    const link = document.createElement('a');
    link.href = globalThis.URL.createObjectURL(response.body);
    link.download = response.headers.get('file-name');
    document.body.appendChild(link);
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: globalThis as Window & typeof globalThis }));
    link.remove();
    globalThis.URL.revokeObjectURL(link.href);
    this.isSuccessToster = true;
    this.message = successMessage;
  }


}
